<script>
export default {
  name: 'KyeReportCardQuestion',
  props: {
    popover: {
      type: Object,
    },
    icon: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconClass() {
      return this.icon || 'layout layout-report-question'
    }
  },
  render () {
    if (!this.$props.popover) return null
    const [childen] = this.$slots.default || []
    const attrs = {
      props: {
        placement: 'top',
        trigger: 'hover',
        'popper-class': 'kye-report-popover-class',
        ...this.$props.popover,
      }
    }
    return this.$props.popover ? (<el-popover
      {...attrs}
    >
      <i
        class={['kye-report-question-icon', this.iconClass]}
        slot="reference"
        on-click={this.handleClick}
      >
      </i>
      {
        childen
      }
    </el-popover>) : null
  },
  methods: {
    handleClick() {
      console.log('question-click')
      this.$emit('click')
    }
  }
}
</script>
<style lang="less">
.kye-report-question-icon {
  color: #999999;
  font-size: 12px;
  &:hover {
    color: var(--g-color-primary);
  }
}
.kye-report-popover-class {
  padding: 10px 12px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/common/question.vue